import "./AppInputSelectV2.scss";

import React, { useMemo } from "react";

import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Select from "react-select";

const AppInputSelectV2 = ({
  label,
  required = false, // ✅ NOVO
  onChange,
  name,
  formText,
  options = [],
  showOptionAll = false,
  value,
  placeholder = "Selecione...",
  optionAllLabel = "Todos",
  isSearchable = true,
  isDisabled = false,
}) => {
  const normalizedOptions = useMemo(() => {
    const mapped = (options || []).map((o) => ({
      value: o?.value ?? "",
      title: o?.title ?? o?.label ?? "",
      subtitle: o?.subtitle ?? "",
    }));

    if (!showOptionAll) return mapped;

    return [
      { value: "", title: optionAllLabel, subtitle: "" },
      ...mapped,
    ];
  }, [options, showOptionAll, optionAllLabel]);

  const selectedOption = useMemo(() => {
    const v = value ?? "";
    return normalizedOptions.find((o) => String(o.value) === String(v)) || null;
  }, [normalizedOptions, value]);

  const emitChange = (opt) => {
    const nextValue = opt?.value ?? "";
    onChange?.({
      target: {
        name,
        value: nextValue,
      },
    });
  };

  return (
    <FloatingLabel
      controlId={name}
      className="mb-3 custom-input-label"
      label={
        <span className="ha-label">
          {label}
          {required && <span className="ha-label__required">*</span>}
        </span>
      }
    >
      <div className="ha-rselect-wrap">
        <Select
          classNamePrefix="ha-rselect"
          isDisabled={isDisabled}
          isSearchable={isSearchable}
          placeholder={placeholder}
          options={normalizedOptions}
          value={selectedOption}
          onChange={emitChange}
          filterOption={(candidate, input) => {
            const txt = String(input || "").toLowerCase().trim();
            if (!txt) return true;
            const t = String(candidate?.data?.title || "").toLowerCase();
            const s = String(candidate?.data?.subtitle || "").toLowerCase();
            return t.includes(txt) || s.includes(txt);
          }}
          formatOptionLabel={(opt, { context }) => {
            if (context === "value") {
              return (
                <div className="ha-rselect__value">
                  <div className="ha-rselect__title">{opt.title}</div>
                  {!!opt.subtitle && (
                    <div className="ha-rselect__subtitle">{opt.subtitle}</div>
                  )}
                </div>
              );
            }

            return (
              <div className="ha-rselect__option">
                <div className="ha-rselect__title">{opt.title}</div>
                {!!opt.subtitle && (
                  <div className="ha-rselect__subtitle">{opt.subtitle}</div>
                )}
              </div>
            );
          }}
          getOptionLabel={(opt) => opt.title}
          getOptionValue={(opt) => String(opt.value)}
        />

        {formText ? (
          <Form.Text muted className="ha-rselect-help">
            <p>{formText}</p>
          </Form.Text>
        ) : null}
      </div>
    </FloatingLabel>
  );
};

export default AppInputSelectV2;
